import { isNotOpenCatalogedModal } from "@/atoms/item/is-not- open-cataloged-modal";
import { isNotOpenDisplayedModal } from "@/atoms/item/is-not-open-displayed-modal";
import { isNotOpenForSaleModal } from "@/atoms/item/is-not-open-for-sale-modal";
import { isOpenCatalogedModal } from "@/atoms/item/is-open-cataloged-modal";
import { isOpenDiscountModal } from "@/atoms/item/is-open-discount-modal";
import { isOpenDisplayedModal } from "@/atoms/item/is-open-displayed-modal";
import { isOpenForSaleModal } from "@/atoms/item/is-open-for-sale-modal";
import { isOpenPriceModal } from "@/atoms/item/is-open-price-modal";
import { itemPageState } from "@/atoms/item/item-page-state";
import { profileState } from "@/atoms/user/profile-state";
import { ButtonColor } from "@/common/enum/button-color";
import { CatalogStatus } from "@/common/enum/catalog-status";
import { DisplayStatus } from "@/common/enum/display-status";
import { Permission } from "@/common/enum/permission";
import { SaleStatus } from "@/common/enum/sale-status";
import { GrayMinusButton } from "@/components/button/GrayMinusButton";
import { GrayPlusButton } from "@/components/button/GrayPlusButton";
import { RefreshButton } from "@/components/button/RefreshButton";
import { Body14RegularInput } from "@/components/input/Body14RegularInput";
import { Body14Regular } from "@/components/typography/Body14Regular";
import { Body14Underline } from "@/components/typography/Body14Underline";
import { itemService } from "@/services/item-service";
import { ItemDetailDto } from "@/types/dto/item-detail-dto";
import { Table, TextInput, Checkbox } from "flowbite-react";
import { useRef, useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import validator from "validator";
import { formatCommasNumber } from "../../../common/util/format-number-with-commas";
import { CustomCell } from "../CustomCell";

interface Props {
  data: ItemDetailDto;
  index: number;
  startIndex: number;
  handleItemNameClick: (id: number) => void;
  isSelected: boolean;
  onSelectItem: (id: number, isSelected: boolean) => void;
}

export const ItemMainTableRow: React.FC<Props> = ({
  data,
  index,
  startIndex,
  handleItemNameClick,
  isSelected,
  onSelectItem,
}) => {
  const item = data;
  const currentUser = useRecoilValue(profileState);
  const setItemPage = useSetRecoilState(itemPageState);
  const setIsCatalogedModalOpen = useSetRecoilState(isOpenCatalogedModal);
  const setIsForSaleModalOpen = useSetRecoilState(isOpenForSaleModal);
  const setIsDisplayedModalOpen = useSetRecoilState(isOpenDisplayedModal);
  const setIsNotCatalogedModalOpen = useSetRecoilState(isNotOpenCatalogedModal);
  const setIsNotForSaleModalOpen = useSetRecoilState(isNotOpenForSaleModal);
  const setIsNotDisplayedModalOpen = useSetRecoilState(isNotOpenDisplayedModal);
  const [, setIsPriceModalOpen] = useRecoilState(isOpenPriceModal);
  const [, setIsDiscountModalOpen] = useRecoilState(isOpenDiscountModal);

  const [to, setTo] = useState<NodeJS.Timeout>();

  const [price, setPrice] = useState<number>(Number(item.price));

  const priceInputRef = useRef<HTMLInputElement>(null); // TextInput 참조 생성

  const isReadOnlyUser =
    currentUser?.role === "ADMIN" &&
    currentUser?.permission === Permission.READ;

  const manageItem = async (field: string, value: any) => {
    try {
      const manageResponse = await itemService.manage(data.id, {
        [field]: value,
      });
      if (!manageResponse.ok) {
        setPrice(data.price);
        return;
      }
      const getByIdResponse = await itemService.getById({ id: data.id });
      if (!getByIdResponse.ok) {
        return;
      }
      setItemPage((prev) => ({
        ...prev,
        contents: prev.contents.map((item) =>
          item.id === getByIdResponse.data.id ? getByIdResponse.data : item
        ),
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleMinOrderQuantityMinusButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    const newMinOrderQuantity = data.minOrderQuantity - 1;
    manageItem("minOrderQuantity", newMinOrderQuantity);
  };

  const handleMinOrderQuantityPlusButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
    const newMinOrderQuantity = data.minOrderQuantity + 1;
    manageItem("minOrderQuantity", newMinOrderQuantity);
  };

  const handlePriceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (to) {
      clearTimeout(to);
    }
    if (item.isForSale) {
      setIsDiscountModalOpen(true);
      return;
    }

    const { value } = event.target;
    console.log("value", value);
    const newPrice = value.replace(/,/g, "") || "0";
    if (!validator.isNumeric(newPrice)) {
      return;
    }
    // manageItem("price", Number(newPrice));
    setPrice(Number(newPrice));
    setTo(
      setTimeout(() => {
        manageItem("price", Number(newPrice));
      }, 300)
    );
  };

  const handleDiscountRateChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newRate = event.target.value.replace("%", "");
    if (!validator.isNumeric(newRate)) {
      return;
    }
    manageItem("discountRate", Number(newRate));
  };

  const handleIsForSaleClick = () => {
    if (item.price === 0) {
      setIsPriceModalOpen(true);
      return;
    }

    if (item.isForSale) {
      setIsForSaleModalOpen(item);
    } else {
      setIsNotForSaleModalOpen(item);
    }
  };

  const handleIsDisplayedClick = () => {
    if (item.price === 0) {
      setIsPriceModalOpen(true);
      return;
    }

    if (item.isDisplayed) {
      setIsDisplayedModalOpen(item);
    } else {
      setIsNotDisplayedModalOpen(item);
    }
  };

  const handleIsCatalogedClick = () => {
    if (item.isCataloged) {
      setIsCatalogedModalOpen(item);
    } else {
      setIsNotCatalogedModalOpen(item);
    }
  };

  const handlePriceClick = () => {
    if (item.isForSale) {
      setIsDiscountModalOpen(true);
    }
  };

  const handleQuantityChange = (value: string) => {
    const numberValue = Number(value);
    manageItem("minOrderQuantity", numberValue);
  };

  return (
    <Table.Row
      key={item.id}
      className={`bg-white text-semantic-text-body ${
        item.memos.length > 0 ? "h-[80px]" : "h-[60px]"
      }`}
    >
      <Table.Cell>
        <CustomCell>
          <Checkbox
            checked={isSelected}
            onChange={(e) => onSelectItem(item.id, e.target.checked)}
            disabled={item.price === 0}
          />
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {startIndex - index}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular>{item.category.name}</Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell
        className="cursor-pointer"
        onClick={() => handleItemNameClick(item.id)}
      >
        <CustomCell>
          {item.imageUrls.length > 0 && (
            <img
              src={item.imageUrls[0]}
              alt={item.name}
              className="w-[32px] mr-[8px]"
            />
          )}
          <div className="flex flex-col">
            <Body14Underline>{item.name}</Body14Underline>
            {item.memos.length > 0 && (
              <p className="mt-1 text-xs">{item.memos.length}개의 상품 메모</p>
            )}
          </div>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <div className="flex items-center">
            <GrayMinusButton
              handleClick={handleMinOrderQuantityMinusButtonClick}
            />
            <Body14RegularInput
              key={item.minOrderQuantity}
              minNumber={0}
              className="mx-[10px]"
              onChange={(value) => handleQuantityChange(value)}
            >
              {item.minOrderQuantity}
            </Body14RegularInput>
            <GrayPlusButton
              handleClick={handleMinOrderQuantityPlusButtonClick}
            />
          </div>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <div className="flex items-center justify-center">
          {isReadOnlyUser ? (
            <Body14Regular>{formatCommasNumber(price)}</Body14Regular>
          ) : (
            <TextInput
              ref={priceInputRef}
              className="w-[88px] mx-[16px]"
              id="price"
              type="text"
              value={formatCommasNumber(price)}
              onChange={handlePriceChange}
              onClick={handlePriceClick}
            />
          )}
        </div>
      </Table.Cell>
      <Table.Cell>
        <div className="flex items-center justify-center">
          {isReadOnlyUser ? (
            <Body14Regular>{`${data.discountRate}%`}</Body14Regular>
          ) : (
            <TextInput
              className="w-[88px] mx-[16px]"
              id="discountRate"
              type="text"
              value={`${data.discountRate}%`}
              onChange={(event) => handleDiscountRateChange(event)}
            />
          )}
        </div>
      </Table.Cell>
      <Table.Cell>
        <div className="flex items-center justify-center">
          {formatCommasNumber(data.priceBydefaultDiscount)}
        </div>
      </Table.Cell>
      <Table.Cell>
        <div className="flex items-center justify-center">
          <RefreshButton
            color={item.isForSale ? ButtonColor.GREEN : ButtonColor.RED}
            handleClick={handleIsForSaleClick}
          >
            {item.isForSale ? SaleStatus.FOR_SALE : SaleStatus.NOT_FOR_SALE}
          </RefreshButton>
        </div>
      </Table.Cell>
      <Table.Cell>
        <div className="flex items-center justify-center">
          <RefreshButton
            color={item.isDisplayed ? ButtonColor.GREEN : ButtonColor.RED}
            handleClick={handleIsDisplayedClick}
          >
            {item.isDisplayed
              ? DisplayStatus.DISPLAYED
              : DisplayStatus.NOT_DISPLAYED}
          </RefreshButton>
        </div>
      </Table.Cell>
      <Table.Cell onClick={handleIsCatalogedClick}>
        <div className="flex items-center justify-center">
          <RefreshButton
            color={item.isCataloged ? ButtonColor.GREEN : ButtonColor.RED}
            handleClick={handleIsCatalogedClick}
          >
            {item.isCataloged
              ? CatalogStatus.CATALOGED
              : CatalogStatus.NOT_CATALOGED}
          </RefreshButton>
        </div>
      </Table.Cell>
    </Table.Row>
  );
};
